import React, { useState } from 'react';
import { URLS } from '../_config';
import { useUserApi } from '../store/api/hooks/userApiHook';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Icon from '../components/icons';
import Spinner from '../components/iconSvgs/spinner';

const SignUp: React.FC = () => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState(false);

    const userAPI: any = useUserApi();
    const { control, register, formState: { errors }, handleSubmit, } = useForm<any>();
    const navigate = useNavigate();


    const togglePassword = () => {
        setShowPassword(!showPassword);
    };


    const onSubmit = (data: any) => {
        // console.log(data);
        setOnSubmitLoading(true);
        const param = {
            name: data.name,
            email: data.email,
            password: data.password,
            role: 'customer'
        }
        try {
            setTimeout(() => {
                userAPI.register(param, (message: any, resp: any) => {
                    console.log('response =>', resp);
                    if (resp?.code === 201) {
                        toast.success(resp?.message);
                        navigate(URLS.USER.LOGIN);
                    } else {
                        toast.error(resp?.message);
                    }
                }, (err: any) => {
                    console.log('error =>', err);
                    toast.error(err);
                });
                setOnSubmitLoading(false);
            }, 3000);
        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen">
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            
            <div className="flex flex-col justify-center items-center w-full lg:w-4/12 sm:w-4/12 px-6 py-12 lg:px-8 bg-white">
                <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
                    <img className="h-15 w-auto mb-[92px]" src="/assets/images/Frame_2.png" alt="hubwallet logo" />
                    <h2 className="mt-10 text-left text-2xl font-bold tracking-tight text-gray-800">Sign Up to HubWallet</h2>
                    <p className="mt-1 text-left text-base tracking-tight text-gray-500">Enter your registration details please</p>
                </div>

                <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-2xl">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-4">
                            <div className="mt-2 relative">
                                <input
                                    type="text"
                                    {...register("name", { required: true })}
                                    placeholder="Enter your Name"
                                    autoComplete="username"
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.email ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name="user" size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" />

                            </div>
                        </div>
                        <div className="mb-4">
                            <div className="mt-2 relative">
                                <input
                                    type="email"
                                    {...register("email", { required: true })}
                                    placeholder="Enter your Email Id"
                                    autoComplete="username"
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.email ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name="email" size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" />

                            </div>
                        </div>

                        <div className="mb-4">
                            <div className="mt-2 relative">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    {...register("password", { required: true })}
                                    autoComplete="current-password" placeholder='Enter your Password'
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.password ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name={showPassword ? 'eye' : 'eye-off'} size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" onClick={togglePassword} />
                            </div>

                        </div>


                        <div className="mb-3">
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-sm bg-blue-500 p-4 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Sign Up
                            </button>
                        </div>
                    </form>

                    <p className="text-center text-sm/6 text-gray-500">
                        Already a member?&nbsp;
                        <Link to={URLS.USER.LOGIN} className="font-semibold text-blue-600 hover:text-blue-500">Sign In</Link>
                    </p>
                </div>
            </div>

            {/* Right Side: Background Image Section */}
            <div className="hidden sm:block lg:w-8/12 sm:w-8/12 bg-cover" style={{ backgroundImage: 'url(/assets/images/2148204009.jpg)' }}>
            </div>
        </div>
    );
};

export default SignUp;